<div class="mb-xl">
  <h1 class="font-headline-lg text-headline-lg text-text-main dark:text-on-surface mb-1">
    Welcome{{ authService.account()?.name ? ', ' + authService.account()!.name!.split(' ')[0] : '' }}
  </h1>
  <p class="text-text-muted dark:text-on-surface-variant font-body-sm text-body-sm">
    {{ authService.roles().length ? authService.roles().join(', ') + ' access' : 'TraXtion Field Service' }}
  </p>
</div>

@if (authService.roles().length === 0) {
  <div class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-8 text-center shadow-sm max-w-lg">
    <span class="material-symbols-outlined text-[40px] text-text-muted dark:text-on-surface-variant mb-3 inline-block">lock</span>
    <h2 class="font-headline-sm text-headline-sm text-text-main dark:text-on-surface mb-2">No access assigned yet</h2>
    <p class="text-text-muted dark:text-on-surface-variant font-body-sm text-body-sm">
      Your account is signed in, but you haven't been assigned an Admin, Operations, Technician, or CSM role yet.
      Contact your administrator to get access to Field Service.
    </p>
  </div>
} @else {
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-gutter max-w-4xl">
    @if (authService.canSeeOperations()) {
      <a routerLink="/dashboard" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">dashboard</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">Dashboard</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">Jobs, technicians, and dealer stats at a glance</p>
        </div>
      </a>
      <a routerLink="/jobs" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">assignment</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">Jobs &amp; Dispatch</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">Create and manage service jobs</p>
        </div>
      </a>
      <a routerLink="/dealers" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">store</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">Dealers</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">Manage dealer accounts</p>
        </div>
      </a>
      <a routerLink="/scheduling" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">calendar_month</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">Scheduling</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">Day/week view of dispatched jobs</p>
        </div>
      </a>
    }
    @if (authService.canSeeTechnicians()) {
      <a routerLink="/my-jobs" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">checklist</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">My Jobs</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">Update status on jobs assigned to you</p>
        </div>
      </a>
      <a routerLink="/notifications" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">notifications</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">Notifications</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">Jobs assigned or cancelled</p>
        </div>
      </a>
      <a routerLink="/technician-inventory" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">inventory_2</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">Inventory</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">Report what tools/parts you're carrying</p>
        </div>
      </a>
      <a routerLink="/technician-performance" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">insights</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">Performance</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">Ratings from completed job surveys</p>
        </div>
      </a>
      <a routerLink="/nearby-dealers" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">near_me</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">Nearby Dealers</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">Proactively check in on dealers near you</p>
        </div>
      </a>
    }
    @if (authService.isCsmOnly()) {
      <a routerLink="/scheduling" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">calendar_month</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">Scheduling</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">Day/week/month view of dispatched jobs</p>
        </div>
      </a>
      <a routerLink="/dealer-map" class="bg-background dark:bg-surface-container-low border border-border-subtle dark:border-outline-variant rounded-xl p-6 flex flex-col gap-3 shadow-sm hover:border-[#00B9F2] transition-colors">
        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-surface-variant flex items-center justify-center text-[#00B9F2]">
          <span class="material-symbols-outlined">map</span>
        </div>
        <div>
          <p class="font-label-md text-text-main dark:text-on-surface mb-0.5">Dealer Map</p>
          <p class="text-text-muted dark:text-on-surface-variant text-xs">See where active Drive Over dealers are located</p>
        </div>
      </a>
    }
  </div>
}
